import { useMutation } from "@tanstack/react-query";
import { useAccessToken, useTenantData } from "@/hooks";
import { PaymentApi } from "@/openapi/generated";
import type { ValidateSurchargeRequest } from "@/openapi/generated";
import { createAuthenticatedApi } from "@/lib/utils";
import { parseSurchargeDisclosureValidateResponseBody } from "@/features/balance/utils/surcharge-disclosure";

export const useSurchargeDisclosureValidate = () => {
  const accessToken = useAccessToken();
  const { tenantId } = useTenantData();

  return useMutation({
    retry: false,
    mutationFn: async (validateSurchargeRequest: ValidateSurchargeRequest) => {
      if (!accessToken) {
        throw new Error("Authentication token is required");
      }

      const service = createAuthenticatedApi(PaymentApi, accessToken);
      const apiResponse = await service.apiPaymentsSurchargeDisclosureValidatePostRaw({
        validateSurchargeRequest,
        xTenantID: tenantId,
      });

      const body = await apiResponse.raw.text();
      return parseSurchargeDisclosureValidateResponseBody(body);
    },
  });
};
